import {
  Component,
  computed,
  HostBinding,
  inject,
  input,
  model,
} from '@angular/core';
import { BaseConfig } from '../../common/config/config.adapter';
import { Align } from '../../common/types';
import { DataGridStore } from '../store/data-grid.store';
import type { ColumnDefinition } from '../types/column.type';
import type { GridOptions } from '../types/grid-options.type';

@Component({
  selector: 'lepi-grid-table-adapter',
  template: '',
  standalone: true,
})
export class GridViewBase extends BaseConfig {
  @HostBinding('class') public class = 'w-full overflow-hidden';

  protected readonly store = inject(DataGridStore);

  // Raw inputs (used by BaseDataGrid for processing)
  public readonly _rawOptions = input<GridOptions | null>(null, {
    alias: 'options',
  });
  public readonly _rawColumns = input<ColumnDefinition[] | null>(null, {
    alias: 'columns',
  });
  public readonly _rawRowData = input<any[] | null>(null, {
    alias: 'rowData',
  });

  // Processed data from store (used by views for display)
  public readonly options = computed(() => this.store.options());
  public readonly columns = computed(() => this.store.columns());
  public readonly rowData = computed(() => this.store.rowData());

  // 정렬, 그룹화 등 옵션 On/Off
  public readonly showHeaderOption = input<boolean>(true);

  public align = model<Align>('desc');
  public orderBy = model<string>('createdAt');

  public selecteds = model<any[]>([]);
}
